import { Rocket } from "@mui/icons-material";
import { Grid } from "../Grid";
import { Typography } from "../Typography";
import { StyledAppBar } from "./styled";
import { IAppBarProps } from "./types";
import { Box } from "@mui/material";

const AppBar = ({children, brandName, ...props}: IAppBarProps)=>(
    <StyledAppBar {...props} elevation={0}>
        <Grid container gap={2} sx={{ flex: 1 }}>
            <Grid item>
                <Grid container gap={1} alignItems="center">
                    {props.icon}
                    <Typography
                        variant="h1"
                        sx={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        {brandName}
                    </Typography>
                </Grid>
            </Grid>
        </Grid>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1}}>
            {children}
        </Box>
    </StyledAppBar>
)

export {AppBar}